module.exports = __webpack_public_path__ + "static/img/newLogo.f473e13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newLogo.png
// module id = JN3v
// module chunks = 26